import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-home-layout',
    template: `
    <app-homenav class="app-wrapper"></app-homenav>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomeLayoutComponent {}
